<template>
  <div>
    <a-form :model="searchForm" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }">
      <a-row>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="发布平台">
            <a-cascader v-model="line_ids" :options="options" change-on-select placeholder="请选择"
                        @change="orgChange" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="关键字">
            <a-input v-model="searchForm.keyword_fuzzy" allowClear placeholder="请输入关键字"
                     style="width: 100%" />
          </a-form-item>
        </a-col>
        <a-col :xs="12" :sm="8" :md="8" :lg="6" :xl="6">
          <a-form-item label="创建时间">
            <v-range-picker v-model="times" @change="onChange" :placeholder="['开始时间', '结束时间']" />
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
    <!-- 搜索按钮 -->
    <div class="flex-sb">
      <div>
        <a-button type="primary" icon="plus-circle" @click="handleAddKeyword">添加关键词</a-button>
        <a-button icon="delete" style="margin-left: 5px" @click="handleClearAll">批量删除</a-button>
        <span style="padding-left: 10px; font-size: 12px; color: #666666a1">
          在文章页内出现对应关键词时，可直接点击关键词新窗口打开链接地址(相同的链接文字
          一篇文章中只添加一次，一个段落最多替换3个关键词，一篇文章最多替换5个关键词)
        </span>
      </div>
      <div>
        <a-button type="primary" icon="search" style="margin-right: 10px" @click="search">查询</a-button>
        <a-button type="primary" icon="delete" ghost @click="handleClear">清空</a-button>
      </div>
    </div>

    <!-- 表格 -->
    <a-table row-key="id" :columns="columns" :loading="loading" :data-source="data"
             :row-selection="{ selectedRowKeys: ids, onChange: onSelectChange }" style="margin-top: 20px"
             @change="handleTableChange" :pagination="pagination">
      <template slot="project" slot-scope="text, record">
        <span>{{ getOrg(record) }}</span>
      </template>
      <template slot="createdUser" slot-scope="text, record">
        {{ record.createdUser.name }}({{ record.createdUser.number }})
      </template>
      <template slot="operator" slot-scope="text, record">
        <!-- <a-button size="small" type="link" @click="handleTableCommand('edit', record)">编辑</a-button> -->
        <a-button size="small" type="link" @click="handleTableCommand('delete', record)">删除</a-button>
      </template>
    </a-table>

    <!-- 添加/编辑关键词 -->
    <a-modal width="40%" v-model="visible" :title="isEdit ? '编辑关键词' : '添加关键词'" :afterClose="handleCancel">
      <a-form-model ref="formDom" :model="form" :rules="rules" :label-col="{ span: 6 }"
                    :wrapper-col="{ span: 16 }">
        <a-form-model-item label="发布平台" prop="line_id">
          <a-select v-model="form.line_id" allowClear show-search option-filter-prop="children"
                    placeholder="请输入或选择" :disabled="isEdit">
            <a-select-option v-for="item in platformList" :key="item.id" :value="item.id">{{
              item.org
            }}</a-select-option>
          </a-select>
          <div style="font-size: 12px; color: #9d9d9d; line-height: 18px">
            业务线范围向下兼容，比如选择“鱼爪”则鱼爪及其所有二级、三级业务线都生效，如选择“鱼爪>知识产权”则“鱼爪>知识产权”及其下的所有级业务线都生效
          </div>
        </a-form-model-item>
        <a-form-model-item label="关键词" prop="keyword">
          <a-input v-model.trim="form.keyword" allowClear :maxLength="30" placeholder="请输入关键词"
                   :disabled="isEdit" />
        </a-form-model-item>
        <a-form-model-item label="跳转链接" prop="jump_link">
          <a-input v-model.trim="form.jump_link" allowClear :maxLength="200" placeholder="请输入跳转链接" />
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCancel"> 取 消 </a-button>
        <a-button key="submit" type="primary" :loading="loading" @click="handleSubmit"> 提 交 </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { ref, reactive, onMounted, toRefs, getCurrentInstance } from '@vue/composition-api'
import pagination from '@/composables/pagination'
import { searchForm, columns, form, rules } from './business/filialeList'
import { strategyCommand } from './business/tableList'
import api from '@/api/'
import moment from 'moment'

export default {
  components: {},
  name: 'KeywordIndex',
  setup(props, { root }) {
    // 获取当前实例
    const _this = getCurrentInstance()
    // 分页信息
    const pagData = pagination()
    const { handleTableChange } = pagData
    const state = reactive({
      ...pagData,
      columns,
      times: [],
      platformList: [],
      ids: [],
      rules,
      form: { ...form },
      searchForm: { ...searchForm },
      options: [], // 平台树数据
      line_ids: [], // 发布平台
    })

    onMounted(async () => {
      await methods.getPlatform()
      methods.getList()
    })

    const methods = {
      onChange(date, dateString) {
        if (dateString[0] === '') {
          this.searchForm.created_at = []
          return
        }
        this.searchForm.created_at = [
          moment(dateString[0]).startOf('day').format('X'),
          moment(dateString[1]).endOf('day').format('X'),
        ]
      },
      // 获取平台列表
      async getPlatform() {
        const res = await api.LineListNew()
        if (res.code === '000000' && res.data && Array.isArray(res.data)) {
          state.platformList = res.data
          const data = res.data.map((item) => {
            const params = {
              id: parseInt(item.id),
              parent_id: item.parent_id,
              label: item.name,
              value: parseInt(item.id),
              org: item.org,
              project: item.project,
              staff_style: item.staff_style,
              type: item.type,
            }
            return params
          })
          state.options = this.buildTree(data, 0)
        }
      },
      buildTree(arr, parentId) {
        const children = arr.filter((node) => node.parent_id === parentId)
        if (!children.length) {
          return []
        }
        return children.map((node) => ({
          ...node,
          children: this.buildTree(arr, node.id),
        }))
      },
      // 列表
      async getList() {
        _this.loading = true
        const res = await api.ListKeywords({
          ..._this.searchForm,
          page: _this.pagination.current,
          per_page: _this.pagination.pageSize,
        })
        const { list, pagination } = res.data
        _this.data = list
        _this.pagination.total = Number(pagination.total)
        _this.loading = false
      },

      // 添加关键词
      handleAddKeyword() {
        _this.visible = true
        _this.isEdit = false
      },

      // 批量删除
      handleClearAll() {
        strategyCommand['deletaAll'].call(_this, this.ids)
      },

      // 表格变化事件
      handleTableCommand(type, ...arg) {
        strategyCommand[type].call(_this, ...arg)
      },

      // 查询
      search() {
        _this.pagination.current = 1
        this.getList()
      },
      // 清空
      handleClear() {
        state.searchForm = { ...searchForm }
        state.line_ids = []
        state.times = []
        this.search()
      },
      orgChange(val, selectedOptions) {
        if (val.length > 0) {
          state.searchForm.line_id = val[val.length - 1]
          const select_item = selectedOptions[selectedOptions.length - 1]
          const { project, staff_style, type } = select_item
          state.searchForm.project = project
          state.searchForm.staff_style = staff_style
          state.searchForm.type = type
        } else {
          state.searchForm.line_id = undefined
          state.searchForm.project = undefined
          state.searchForm.staff_style = undefined
          state.searchForm.type = undefined
        }
      },
      getOrg(record) {
        const obj = this.platformList.find(
          (item) =>
            item.project.toString() === record.project &&
            item.staff_style.toString() === record.staff_style &&
            item.type.toString() === record.type
        )
        return obj ? obj.org : ''
      },
      onSelectChange(ids) {
        this.ids = ids
      },
      // 添加/编辑
      handleSubmit() {
        _this.loading = true
        _this.$refs.formDom.validate(async (valid) => {
          let res = null
          const data = { ..._this.form }
          if (valid) {
            _this.loading = false
            if (_this.isEdit) {
              res = await api.UpdateKeywords({ id: data.id, jump_link: data.jump_link })
            } else {
              const proms = { line_id: data.line_id, keyword: data.keyword, jump_link: data.jump_link }
              res = await api.CreateKeywords(proms)
            }
            if (_this.$validate(res)) {
              this.$message.success(_this.isEdit ? '编辑成功~' : '添加成功~')
              _this.visible = false
              _this.loading = false
              _this.getList()
              _this.$refs.formDom.resetFields()
            } else {
              state.btnloading = false
            }
          } else {
            this.$message.warning('请检查信息是否填写完成')
            _this.loading = false
          }
        })
      },
      // 取消/关闭
      handleCancel() {
        _this.$refs.formDom.resetFields()
        _this.visible = false
      },
    }

    return {
      ...toRefs(state),
      ...methods,
      ...pagination(),
    }
  },
}
</script>
